// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* prettier-ignore */
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    box-sizing: border-box;
    outline: none;
    -webkit-tap-highlight-color: transparent;
}

/* prettier-ignore */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
    display: block;
}

body {
    line-height: 1;
    overscroll-behavior: none;
}

/* prettier-ignore */
blockquote, q {
    quotes: none;
}

/* prettier-ignore */
blockquote:before, blockquote:after,
q:before, q:after {
    content: none;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

button {
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    cursor: pointer;
}

a {
    text-decoration: none;
    color: inherit;
}

input {
    border: 0;
    border-radius: 0;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    margin: 0;
    padding: 0;
    outline: none;
}

* {
    box-sizing: border-box;
}

/* prettier-ignore */
ul, ol {
    list-style: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/reset.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;;;;;;;;;;;;;IAaI,SAAS;IACT,UAAU;IACV,SAAS;IACT,wBAAwB;IACxB,sBAAsB;IACtB,aAAa;IACb,wCAAwC;AAC5C;;AAEA,oBAAoB;AACpB;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,YAAY;AAChB;;AAEA,oBAAoB;AACpB;;IAEI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;AACpB","sourcesContent":["/* prettier-ignore */\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align: baseline;\n    box-sizing: border-box;\n    outline: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n/* prettier-ignore */\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, menu, nav, section {\n    display: block;\n}\n\nbody {\n    line-height: 1;\n    overscroll-behavior: none;\n}\n\n/* prettier-ignore */\nblockquote, q {\n    quotes: none;\n}\n\n/* prettier-ignore */\nblockquote:before, blockquote:after,\nq:before, q:after {\n    content: none;\n}\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\nbutton {\n    margin: 0;\n    padding: 0;\n    border: none;\n    outline: none;\n    cursor: pointer;\n}\n\na {\n    text-decoration: none;\n    color: inherit;\n}\n\ninput {\n    border: 0;\n    border-radius: 0;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    margin: 0;\n    padding: 0;\n    outline: none;\n}\n\n* {\n    box-sizing: border-box;\n}\n\n/* prettier-ignore */\nul, ol {\n    list-style: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
